import apiFetch from './client';

export function getTenantSettings() {
  return apiFetch('/api/tenant');
}

export function updateTenantSettings(data) {
  return apiFetch('/api/tenant', {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

export function getDefaultImagePrompt() {
  return apiFetch('/api/system/image-prompt-default');
}

export function getAiOptions() {
  return apiFetch('/api/ai/options');
}
